import { logging } from '@cornerstonejs/utils';
export const { getRootLogger, getLogger, cs3dLog, coreLog, toolsLog, adaptersLog, loaderLog, niftiVolumeLoaderLog, polySegLog, labelmapInterpolationLog, aiLog, examplesLog, dicomConsistencyLog, imageConsistencyLog, log, } = logging;
export const { workerLog } = logging;
export const growCutLog = toolsLog.getLogger('growCut');
